module.exports = __webpack_public_path__ + "static/media/explore-more-ways-save-background-gbgh-mobile.8be7123e.webp";